module.exports = __webpack_public_path__ + "img/ic-close-2.2b11e5b3.svg";